import { JarvisAuthPages as JarvisReactAuthPages, useDynamicConfig } from "@dgs/core";
import { FC } from "react";
import { useSearchParams } from "react-router";

export const JarvisAuthPages: FC = () => {
	const { authUrl } = useDynamicConfig();
	const [searchParams] = useSearchParams();

	return (
		<JarvisReactAuthPages
			authUrl={authUrl}
			identityProvidersUrl={`${authUrl}/providers`}
			showPasswordReset={true}
			afterSuccessfulLoginPath={searchParams.get("redirect") || "/"}
		/>
	);
};
